import { useStoreState } from "ezStore";
import { Select, SelectProps } from "@cofano/cck";

const RelationProductGroupsSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {

	const { settings } = useStoreState(store => store.session);

	const groups = settings?.multiValues?.customerProductGroup ? settings.multiValues.customerProductGroups.split(";") : [];

	const options = groups.map(group => ({
		id: group,
		name: group,
	}));

	return (
		<Select
			value={options.find(option => option.id === value)}
			fetchOptions={options}
			onChange={option => onChange?.(option?.id ?? null, false)}
			disableSearch />
	);
};
export default RelationProductGroupsSelect;
